import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Mail, Phone, MapPin } from "lucide-react";
import { brand, offices } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[#0B2447] text-slate-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center">
              <ShieldCheck className="w-5 h-5 text-white" />
            </div>
            <div className="text-white font-semibold">{brand.name}</div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            Protecting brand reputation for 5,000+ companies worldwide with policy-based content removal and review management.
          </p>
        </div>

        <div>
          <div className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Services</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-white" to="/services">Online Reputation Management</Link></li>
            <li><Link className="hover:text-white" to="/services">Review Management</Link></li>
            <li><Link className="hover:text-white" to="/services">Content Removal</Link></li>
            <li><Link className="hover:text-white" to="/services">Reputation Monitoring</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-white" to="/about">About</Link></li>
            <li><Link className="hover:text-white" to="/pricing">Pricing</Link></li>
            <li><Link className="hover:text-white" to="/contact">Contact</Link></li>
            <li><a className="hover:text-white" href={brand.whatsapp} target="_blank" rel="noreferrer">WhatsApp us</a></li>
          </ul>
        </div>

        <div>
          <div className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5" /> <a href={`mailto:${brand.email}`} className="hover:text-white break-all">{brand.email}</a></li>
            {brand.phones.map((p) => (
              <li key={p} className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5" /> <span>{p}</span></li>
            ))}
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5" /> <span>{offices[0].country} · {offices[2].country} · {offices[1].country} · {offices[3].country}</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row items-center justify-between text-xs text-slate-400 gap-2">
          <div>© {new Date().getFullYear()} Brand Marketing Professionals · All rights reserved.</div>
          <div>No removal, no fee guarantee</div>
        </div>
      </div>
    </footer>
  );
}
